import {Component, Input} from '@angular/core';
import {AbstractFieldComponent} from '../_abstract/abstract-field.component';

@Component({
    selector: 'field-textarea',
    templateUrl: './field-textarea.component.html',
    styleUrls: [
        './field-textarea.component.scss'
    ],
    standalone: false
})
export class FieldTextareaComponent extends AbstractFieldComponent {
  @Input() rows = 5;
}
